import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Text } from '@uhg-abyss/web/ui/Text';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

/**
 * RiskPublishDate
 *
 * Displays a a date when the risk record was published on from ire.
 *
 * @param ireRiskRecord
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function RiskPublishDate({ ireRiskRecord = {}, riskRecord = {} }) {
  let riskPublishDate = '';

  if (!isUndefined(riskRecord?.streamTimeReceived)) {
    riskPublishDate = riskRecord?.streamTimeReceived;
  }
  if (!isUndefined(ireRiskRecord?.riskReports?.[0]?.publishedDate)) {
    riskPublishDate = ireRiskRecord?.riskReports?.[0]?.publishedDate;
  }

  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Details/components/RiskPublishDate/RiskPublishDate.jsx">
      <React.Fragment>
        {isEmpty(riskPublishDate) ? (
          <Text color="$gray5">&mdash;</Text>
        ) : (
          <Text fontWeight="bold">{dayjs(riskPublishDate).format('YYYY-MM-DD')}</Text>
        )}
      </React.Fragment>
    </ErrorHandler>
  );
}
